import { classNames } from "@/utils/classnames";
import React from "react";
import { H1 as CDSH1, H2 as CDSH2, H3 as CDSH3, H4 as CDSH4, CDSH5, CDSH6 } from "./design-system";

export { CDSH1, CDSH2, CDSH3, CDSH4 };
export { CDSText, CDSH5, CDSH6, DesignSystemTypography, P } from "./design-system";

export const Typography = {
  xs: "text-cds-xs",
  sm: "text-cds-sm",
  md: "text-cds-md",
  lg: "text-cds-lg",
  xl: "text-cds-xl",
  h1: "heading-1",
  h2: "heading-2",
  h3: "heading-3",
  h4: "heading-4",
  h5: "heading-5",
  h6: "heading-6",
  subheader: "subheader",
  subsubheader: "subsubheader",
  link: "link",
  marketingNavLink:
    "text-[13px] leading-[16px] tracking-[0.05em] font-marketing-mono uppercase px-4 py-2 font-[400] inline-block whitespace-nowrap",
  code: "font-mono rounded px-2 py-0.5 bg-zinc-50 text-marketing-green-1 dark:text-white dark:!bg-zinc-600 w-fit",
  codePlain: "font-mono",
};

export const NB_HYPHEN = "‑";

/** @deprecated Prefer components from `frontend/components/typography/design-system.tsx` for new pages and components when possible. */
export const ShrinkingH1: React.FC<{ className?: string; children: string }> = ({
  className,
  children,
}) => {
  return (
    <H1
      className={classNames(
        className,
        children.length >= 64 ? "text-[24px]" : children.length >= 48 ? "text-[28px]" : "",
      )}
    >
      {children}
    </H1>
  );
};

export function H1({ children, className, ...rest }: React.ComponentProps<"h1">) {
  return (
    <CDSH1 className={className} {...rest}>
      {children}
    </CDSH1>
  );
}

export function H2({ children, className, ...rest }: React.ComponentProps<"h2">) {
  return (
    <CDSH2 className={className} {...rest}>
      {children}
    </CDSH2>
  );
}

export function H3({ children, className, ...rest }: React.ComponentProps<"h3">) {
  return (
    <CDSH3 className={className} {...rest}>
      {children}
    </CDSH3>
  );
}

export function H4({ children, className, ...rest }: React.ComponentProps<"h4">) {
  return (
    <CDSH4 className={className} {...rest}>
      {children}
    </CDSH4>
  );
}

export function H5({ children, className, ...rest }: React.ComponentProps<"h5">) {
  return (
    <CDSH5 className={className} {...rest}>
      {children}
    </CDSH5>
  );
}

export function H6({ children, className, ...rest }: React.ComponentProps<"h6">) {
  return (
    <CDSH6 className={className} {...rest}>
      {children}
    </CDSH6>
  );
}

/** @deprecated Prefer components from `frontend/components/typography/design-system.tsx` for new pages and components when possible. */
export function UL({ children, className, ...rest }: React.ComponentProps<"ul">) {
  return (
    <ul className={classNames("ml-4 list-disc", className)} {...rest}>
      {children}
    </ul>
  );
}

/** @deprecated Prefer components from `frontend/components/typography/design-system.tsx` for new pages and components when possible. */
export function Code({ children, className, ...rest }: React.ComponentProps<"span">) {
  return (
    <span className={classNames(Typography.code, className)} {...rest}>
      {children}
    </span>
  );
}

/** @deprecated Prefer components from `frontend/components/typography/design-system.tsx` for new pages and components when possible. */
export function Superheader(props: { text: string }) {
  return (
    <div className="text-xl uppercase font-marketing-mono text-secondary-lime-300">
      <span className="md:block">{props.text}</span>
    </div>
  );
}
